export default __webpack_public_path__ + "static/media/qualitest.84ab71ee.svg";